import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import { Link } from "gatsby"
import parse from "html-react-parser"
import FakeButton from "../global/FakeButton"
import Arrow from ".././../assets/slider-arrow.inline.svg"

const PostsWrapper = styled.div`
  /* overflow:hidden; */
  width: 100%;

  .postWrapper--inner {
    width: calc(100% + 2rem);
    display: flex;
    flex-wrap: wrap;
    padding: 1rem 0;

    @media only screen and (min-width: 1024px) {
      padding: 4rem 0;
    }
  }

  .post-list-item {
    width: calc(100% - 2rem);
    margin-bottom: 2rem;
    display: flex;

    @media only screen and (min-width: 650px) {
      width: calc(50% - 2rem);
      margin-right: 2rem;
    }

    @media only screen and (min-width: 1024px) {
      width: calc(33.33% - 2rem);
      margin-right: 2rem;
    }

    a {
      text-decoration: none;
      color: inherit;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      flex-flow: column;
    }

    .content {
      align-self: flex-end;
      flex-grow: 1;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      flex-direction: column;
    }

    .image-wrapper {
      flex-grow: 0;
    }

    h2 {
      margin-bottom: 1rem;
      color: var(--black);
      transition: 0.5s all ease-in-out;
      text-decoration: none;
      font-family: var(--font-bold);
      font-size: 1.2rem;
      line-height: 1.5rem;
    }

    .button-wrap {
      a {
        font-size: 0.9rem;
      }
    }

    .excerpt {
      font-size: 0.8rem;
      margin-bottom: 1rem;

      p {
        line-height: 1.25rem;
      }
    }

    .image-wrapper {
      width: 100%;
      padding-bottom: 70%;
      position: relative;
      margin-bottom: 1rem;

      &:before {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        background: var(--brandColor);
        top: -1rem;
        left: -1rem;
        transform: translate(1rem, 1rem);
        transition: 0.5s transform ease-in-out;
      }

      .gatsby-image-wrapper {
        width: 100% !important;
        height: 100% !important;
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        background: var(--brandColor);

        img {
          width: 100% !important;
          height: 100% !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          transition: 0.5s all ease-in-out !important;
        }
      }

      &:hover {
        .gatsby-image-wrapper img {
          transform: scale(1.2);
        }

        .image-wrapper:before {
          transform: translate(0, 0);
        }
      }
    }

    &.js_hover {
      .gatsby-image-wrapper img {
        transform: scale(1.2);
      }

      .image-wrapper:before {
        transform: translate(0, 0);
      }

      h2 {
        color: var(--brandColor);
      }
    }
  }
`

const Pagination = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 4rem;
  ul {
    padding: 0;
    list-style: none;
    display: flex;

    li {
      display: flex;
      align-items: center;
      padding: 10px;
      position: relative;
      min-width: 30px;
      min-height: 30px;
      margin-right: 0.5rem;
      transition: 0.5s all ease-in-out;

      &:after {
        border-radius: 100%;
        content: "";
        width: 30px;
        height: 30px;
        background: var(--black);
        position: absolute;
        z-index: 0;
        right: 1px;
        top: 1px;
        opacity: 0;
        transition: 0.5s all ease-in-out;
      }

      &:last-child {
        margin-right: 0;
      }

      a {
        color: var(--black);
        text-decoration: none;
        z-index: 10;
        transition: 0.5s all ease-in-out;
      }

      &.active {
        &:after {
          background: var(--brandColor);
          opacity: 1;
        }
      }

      &:hover {
        a {
          color: var(--white);
        }

        &:after {
          opacity: 1;
        }
      }
    }
  }

  .prev {
    svg {
      transform: scale(-1);
    }
  }

  .next {
  }
`

export default function BlogLoop(data) {
  const posts = data.posts
  const postCat = data.postCat
  const postCatOverride = data.postCatOverride
  const nextPagePath = data.nextPagePath
  const previousPagePath = data.previousPagePath
  const totalPages = data.totalPages
  const currentPage = data.currentPage
  const className = data.className
  const newsCats = data.newsCats

  const handleMouseOver = e => {
    e.target.closest(".post-list-item").classList.add("js_hover")
    e.target
      .closest(".post-list-item")
      .querySelector(".fakeButton")
      .classList.add("js_hover")
  }
  const handleMouseOut = e => {
    e.target.closest(".post-list-item").classList.remove("js_hover")
    e.target
      .closest(".post-list-item")
      .querySelector(".fakeButton")
      .classList.remove("js_hover")
  }

  return (
    <div className={className + " wrapper"}>
      <PostsWrapper>
        <div className="postWrapper--inner">
          {posts.map(post => {
            let postCatOverrideValue =
              post?.categories?.nodes[0].slug + "/" || data.postCat

            if (newsCats) {
              const prefix = post.categories.nodes.filter(cat => {
                {
                  {
                    /* console.log(
                    cat.slug,
                    newsCats,
                    !newsCats.includes(cat.slug),
                    post.title
                  ) */
                  }
                }
                {
                  if (!newsCats.includes(cat.slug) && cat.slug !== "news") {
                    {
                      /* console.log(post.title, cat.slug) */
                    }
                    return cat.slug
                  }
                }
              })

              postCatOverrideValue = prefix[0].slug + "/"

              {
                /* console.log(prefix, post.title) */
              }
            }

            const featuredImage = {
              fluid:
                post.acf_customFeaturedImage?.featuredImage?.localFile
                  ?.childImageSharp?.gatsbyImageData,
              alt: post.acf_customFeaturedImage?.featuredImage?.node?.alt || ``,
            }
            const caseFeaturedImage = {
              fluid:
                post.acf_caseStudyFields?.backgroundImage?.localFile
                  ?.childImageSharp?.gatsbyImageData,
              alt: post.acf_caseStudyFields?.backgroundImage?.node?.alt || ``,
            }
            return (
              <article
                key={postCat === "news" ? "test" : post.uri}
                className="post-list-item"
                itemScope
                itemType="http://schema.org/Article"
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
              >
                {featuredImage?.fluid && (
                  <Link
                    to={
                      postCatOverride === true
                        ? "/" + postCatOverrideValue + post.slug
                        : postCat + "/" + post.slug
                    }
                    itemProp="url"
                  >
                    <div className="image-wrapper">
                      <GatsbyImage
                        image={
                          post.acf_customFeaturedImage.featuredImage.localFile
                            .childImageSharp.gatsbyImageData
                        }
                      />
                    </div>

                    <div className="content">
                      <h2>
                        <span itemProp="headline">{parse(post.title)}</span>
                      </h2>
                      <section className="excerpt">
                        {parse(post?.excerpt?.substring(0, 150) + "....")}
                      </section>
                      <div className="button-wrap">
                        <FakeButton
                          color="black"
                          bg="brandColor"
                          text="Read more"
                          withHover={true}
                        />
                      </div>
                    </div>
                  </Link>
                )}
                {caseFeaturedImage?.fluid && (
                  <Link to={postCat + post.slug} itemProp="url">
                    <div className="image-wrapper">
                      <GatsbyImage
                        image={
                          post.acf_caseStudyFields.backgroundImage.localFile
                            .childImageSharp.gatsbyImageData
                        }
                      />
                    </div>

                    <div className="content">
                      <h2>
                        <span itemProp="headline">{parse(post.title)}</span>
                      </h2>
                      <section className="excerpt">
                        Find out what happened when we worked with{" "}
                        {parse(post.title)}...
                      </section>
                      <div className="button-wrap">
                        <FakeButton
                          color="black"
                          bg="brandColor"
                          text="Read more"
                          withHover={true}
                        />
                      </div>
                    </div>
                  </Link>
                )}
              </article>
            )
          })}
        </div>
      </PostsWrapper>
      <Pagination>
        {previousPagePath && (
          <Link className="prev" to={previousPagePath} title="Previous Page">
            <Arrow />
          </Link>
        )}
        {!previousPagePath && (
          <div className="prev fake">
            <Arrow />
          </div>
        )}
        <ul>
          {Array.from({ length: totalPages }, (_, i) => (
            <li
              key={`pagination-number${i + 1}`}
              className={i === currentPage - 1 ? "active" : ""}
            >
              <Link to={`${i === 0 ? postCat : postCat + "/page/" + (i + 1)}`}>
                {i + 1}
              </Link>
            </li>
          ))}
        </ul>
        {nextPagePath && (
          <Link className="next" to={nextPagePath} title="Next Page">
            <Arrow />
          </Link>
        )}
        {!nextPagePath && (
          <div className="next fake">
            <Arrow />
          </div>
        )}
      </Pagination>
    </div>
  )
}
